import { h } from "omi";

import { IconProps } from "@/components";

export function TypefaceIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M3.33398 5.83301c0-.77657 0-1.16486.12687-1.47114.16916-.40838.49362-.73284.902-.90199.30628-.12687.69457-.12687 1.47113-.12687h8.33332c.7766 0 1.1649 0 1.4712.12687.4083.16915.7328.49361.902.90199.1268.30628.1268.69457.1268 1.47114M7.50065 16.6663h5.00005m-2.5-13.33329V16.6663"
        stroke="currentColor"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
